import './styles/main.css';
import { App } from './app/App';
import { createAnalyticsFromEnv } from './analytics/AnalyticsService';

const app = new App(createAnalyticsFromEnv());
app.init();
